import { AbstractControl, ValidationErrors } from "@angular/forms";

export function integerValidator(opts?: {
  required?: boolean;
  min?: number;
  max?: number;
}) {
  return function (control: AbstractControl): ValidationErrors {
    if (opts && !opts.required) {
      if (control.value === "" || control.value == undefined) {
        return null;
      }
    }

    let value = parseInt(control.value);
    if (opts && opts.min != null && value - opts.min < 0) {
      let error = {};
      error[`Minimum value is ${opts.min}`] = true;
      return error;
    }
    if (opts && opts.max != null && opts.max - value < 0) {
      let error = {};
      error[`Maximum value is ${opts.max}`] = true;
      return error;
    }

    if (
      parseFloat(control.value) == parseInt(control.value) &&
      !isNaN(control.value)
    ) {
      return null;
    }
    return { "Input must be a number": true };
  };
}

export function decimalValidator(opts?: {
  required?: boolean;
  min?: number;
  max?: number;
  invalidMsg?: string;
}) {
  return function (control: AbstractControl): ValidationErrors {
    if (opts && !opts.required) {
      if (control.value === "" || control.value == undefined) {
        return null;
      }
    }
    let pattern = /^-?\d+\.?(\d{1,2})?$/;
    let validated = pattern.test(control.value);
    if (!validated && control.dirty) {
      let error = {};
      if (opts.invalidMsg) {
        error[`${opts.invalidMsg}`] = true;
        return error;
      } else {
        return { "Maximum decimal place is 2.": true };
      }
    }
    let value = parseFloat(control.value);
    if (opts && opts.min && value - opts.min < -0.000001) {
      let error = {};
      error[`Minimum value is ${opts.min}`] = true;
      return error;
    }
    if (opts && opts.max && opts.max - value < -0.000001) {
      let error = {};
      error[`Maximum value is ${opts.max}`] = true;
      return error;
    }
    return null;
  };
}

export function numericOnly(event): boolean {
  // restrict e, E, -, _, +,  "," and "." characters in  input type number
  const charCode = event.which ? event.which : event.keyCode;
  if (
    charCode == 101 ||
    charCode == 44 ||
    charCode == 46 ||
    charCode == 45 ||
    charCode == 95 ||
    charCode == 43 ||
    charCode == 69
  ) {
    return false;
  }
  return true;
}
